export default [
  {
    path: '',
    children: [
      {
        path: '',
        name: 'product list',
        component: () => import('@/views/app/product/list/page-list.vue'),
        meta: { title: 'Daftar Produk' },
      },
      {
        path: ':id/:slug?',
        name: 'product detail',
        component: () => import('@/views/app/product/detail/page-detail.vue'),
        meta: { title: 'Detail Produk' },
      },
    ],
  },
  {
    path: 'grup',
    name: 'product group list',
    component: () => import('@/views/app/product/group/list/page-list.vue'),
    meta: { title: 'Daftar Grup Produk' },
  },
  {
    path: 'barcode',
    children: [
      {
        path: 'produk',
        name: 'product print barcode',
        component: () => import('@/views/app/product/print-barcode/page-list-product.vue'),
        meta: { title: 'Cetak Barcode Produk' },
      },
      {
        path: 'pembelian',
        name: 'purchase print barcode',
        component: () => import('@/views/app/product/print-barcode/page-list-purchase.vue'),
        meta: { title: 'Cetak Barcode Dari Pembelian' },
      },
    ],
  },
  {
    path: 'multiplier-harga',
    name: 'product price multiplier',
    component: () => import('@/views/app/product/multiplier/list/page-list.vue'),
    meta: { title: 'Daftar Multiplier Harga Produk Otomatis' },
  },
  {
    path: 'promo-item',
    name: 'product promo item',
    component: () => import('@/views/app/product/promo-item/page-list.vue'),
    meta: { title: 'Promo Produk' },
  },
  {
    path: 'riwayat-harga-produk',
    name: 'log product price',
    component: () => import('@/views/app/product/log-price/page-list.vue'),
    meta: { title: 'Riwayat Harga Produk' },
  },
  {
    path: 'stok',
    name: 'product check stock',
    component: () => import('@/views/app/product/check-stock/page-list.vue'),
    meta: { title: 'Cek Stok Produk' },
  },
  {
    path: 'hpp',
    children: [
      {
        path: '',
        name: 'product cost of sale',
        component: () => import('@/views/app/product/cost-of-sale/list/page-list.vue'),
        meta: { title: 'Harga Pokok Penjualan' },
      },
      {
        path: ':id',
        name: 'product cost of sale detail',
        component: () => import('@/views/app/product/cost-of-sale/detail/page-detail.vue'),
        meta: { title: 'Harga Pokok Penjualan' },
      },
    ],
  },
]
